<template>
  <div class="a2">
    <div class="container">
      <!-- 主容器，左右布局开始 -->
      <div class="index-box">
        <!-- 左侧 -->
        <div class="index-l">
          <!-- 资讯区块2 -->
          <ac2 :msrc="this.msrc" :mtitle="this.mtitle"></ac2>
        </div>
        <!-- 右侧 -->
        <div class="index-r">
          <!-- 热门文章 -->
          <ac3></ac3>

          <!-- 文章列表 -->
          <ac4></ac4>
        </div>
      </div>
    </div>
    <modal title="请支付阅读" btnType="1" modalType="middle" :showModal="showModal" @submit="showModal = false"
      @cancel="showModal = false">
      <template v-slot:body>
        <img style="display: flex; justify-content: center; width:200px; margin: 0 auto;"
          src="/imgs/pay.png" />
        <h2>微信支付：2元/篇</h2>
      </template>
    </modal>
  </div>
</template>

<script>
import ac2 from "./../components/ac2";
import ac3 from "./../components/ac3";
import ac4 from "./../components/ac4";
import Modal from "./../components/Modal";
export default {
  name: "a2",

  data() {
    return {
      msrc: "/mock/a2.json",
      mtitle: "文化资讯",
      showModal: false,
    };
  },
  components: {
    ac2,
    ac3,
    ac4,
    Modal
  },
};
</script>

<style lang="scss" scoped>
@import "./../assets/scss/base.scss";
@import "./../assets/scss/config.scss";
@import "./../assets/scss/mixin.scss";
.a2 {
  width: 100%;
  margin-top: 100px;
  position: relative;
  .container {
    height: 100%;
    // 主容器
    .index-box {
      height: 100%;
      display: flex;
      justify-content: space-between;
      // align-items: center;
      // 左侧
      .index-l {
        width: 70%;
        height: 100%;
        padding-top: 10px;
        box-sizing: border-box;
        // background-color: pink;
      }
      // 右侧
      .index-r {
        width: 30%;
        margin-left: 40px;
        height: 100%;
        // background-color: #c60023;
      }
    }
  }
}
</style>